export const CHANGE_PAGE = 'APP/CHANGE_PAGE';
export const SET_ACCOUNTS = 'APP/SET_ACCOUNTS';
export const SET_LIQUIDITY_POOL = 'SEND/RECEIVE/SET_LIQUIDITY_POOL';